module.exports = `${require.publicPath}banner-bg.05ee9cac.png`;